import { apiClient } from '../../plugins/api'
import {
    LISTING_REQUEST,
    REMOVE_NOTIFICATION_REQUEST,
    SAVE_TOKEN_REQUEST,
    SAVE_TOKEN_SUCCESS,
} from '../actions/notification'

const state = {
    token: null, //localStorage.getItem('notification-token'),
};

const getters = {
    getToken (state) {
        return state.token;
    },
};

const actions = {
    async [LISTING_REQUEST] () {
        const response = await apiClient().get('/notification/listing');
        return response.data.notifications;
    },
    async [REMOVE_NOTIFICATION_REQUEST] ({ commit }, { notificationId }) {
        await apiClient().post('/notification/remove', { notificationId });
    },
    async [SAVE_TOKEN_REQUEST] ({ commit }, { token }) {
        await apiClient().post('/notification/save-token', { token });
        localStorage.setItem('notification-token', token);
        commit(SAVE_TOKEN_SUCCESS, { token });
    },
};

const mutations = {
    [SAVE_TOKEN_SUCCESS] (state, { token }) {
        state.token = token;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
